<script>
import TabsStatisticAttestation from "./TabsStatisticAttestation.vue";
import BarGraphStatisticAttestation from "./BarGraphStatisticAttestation.vue";
import CardStatisticAttestation from "./CardStatisticAttestation.vue";
import axios from "axios";
import dataStatisticAttestationPartitionFacultyToDrawGraph
  from "./services/dataStatisticAttestationPartitionFacultyToDrawGraph";

export default {
  name: "CardGraphUniversityStatisticAttestation",
  components: {CardStatisticAttestation, BarGraphStatisticAttestation, TabsStatisticAttestation},

  data() {
    return {
      loadingUniversityStatistic: true,
      universityStatisticAttestations: [],
      facultyNames: [],
      controlDates: [],
      convertDataToDrawGraph: dataStatisticAttestationPartitionFacultyToDrawGraph,
    };
  },

  mounted() {
    this.getUniversityAttestationStatistics();
  },

  methods: {
    async getUniversityAttestationStatistics() {
      try {
        const response = await axios.get(`/reports/faculty_attestation_statistics`);
        this.universityStatisticAttestations = response.data.universityStatistics;
        this.facultyNames = response.data.meta.departmentAbbreviations;
        this.controlDates = response.data.meta.dateAttestations;
      } catch (err) {
        console.log(err);
      }
      this.loadingUniversityStatistic = false;
    },
  }
}
</script>

<template>
  <card-statistic-attestation :loading="loadingUniversityStatistic">
    <template #default>
      <v-card-title>Университет</v-card-title>
      <tabs-statistic-attestation
        addition-name-key="Университет"
        :date-attestations="controlDates"
        sheet-class="d-flex justify-center"
      >
        <template #default="{dateAttestation}">
          <bar-graph-statistic-attestation
            :xaxis="facultyNames"
            :series="convertDataToDrawGraph(universityStatisticAttestations, dateAttestation.date)"
            :width="facultyNames.length * 100"
          />
        </template>
      </tabs-statistic-attestation>
    </template>
  </card-statistic-attestation>
</template>

<style scoped>

</style>